import { isEmpty } from "@swiggy-private/js-utils";
import { captureError, isValidNumber } from "@swiggy-private/core-ui";

import { replaceLottiePlaceholders } from "./lottiePlaceholder";
import { MRO_ORDER_COUNT_PLACEHOLDER } from "../constants";
import { OnTransitionError, TRANSITION_ERROR_TYPES } from "../interfaces";

export const updateDynamicValuesInMROLottieData = (lottieData: unknown, childOrdersCount?: number) => {
    if (isEmpty(lottieData)) {
        return lottieData;
    }

    if (isValidNumber(childOrdersCount) && childOrdersCount != null && childOrdersCount > 1) {
        return (
            replaceLottiePlaceholders(lottieData, {
                [MRO_ORDER_COUNT_PLACEHOLDER]: `${childOrdersCount}`,
            }) ?? lottieData
        );
    }

    return lottieData;
};

/** Module-level cache so prefetch + mount share one in-flight/completed fetch per URL. */
const lottiePromiseByUrl = new Map<string, Promise<unknown>>();

const loadTransitionStripLottie = (url: string): Promise<unknown> => {
    const cachedPromise = lottiePromiseByUrl.get(url);
    if (cachedPromise) {
        return cachedPromise;
    }

    const promise = fetch(url || "")
        .then((response) => response.json())
        .catch((error) => {
            lottiePromiseByUrl.delete(url);
            throw error;
        });

    lottiePromiseByUrl.set(url, promise);
    return promise;
};

/** Fire-and-forget warm of the strip lottie cache (HTTP + in-memory). */
export const prefetchTransitionMROStripLottie = (url: string) => {
    void loadTransitionStripLottie(url).catch((error) => {
        captureError(error);
    });
};

interface FetchTransitionMROStripLottie {
    url: string;
    onError?: OnTransitionError;
}

export const fetchTransitionMROStripLottie = async ({
    url,
    onError,
}: FetchTransitionMROStripLottie): Promise<unknown> => {
    try {
        return await loadTransitionStripLottie(url);
    } catch (e) {
        captureError(e);
        onError?.(TRANSITION_ERROR_TYPES.FETCH_FAILED, e, url);
    }
};
